import React from "react";
import Underline from "./Underline";

const DashboardTitle = ({ children }) => {
  return (
    <div className="relative my-2">
      <h2 className="text-2xl font-semibold pb-0.5 dashboard-title">{children}</h2>
     

      <Underline />
    
    </div>
  );
};

export default DashboardTitle;
